import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=b5d0f670&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Player.vue?vue&type=style&index=1&id=b5d0f670&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d0f670",
  null
  
)

export default component.exports